import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceBase } from '../shared/servicebase';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EstadoCidadeService extends ServiceBase {

  constructor(http: HttpClient) {
    super(http);
  }

  public ListarEstados(filtro: string, status: string, pagina: number, tamanhoPagina: number): Observable<any> {
    const parametros: string[] = [];

    if ((filtro || '').trim()) {
      parametros.push('filtro=' + encodeURIComponent((filtro || '').trim()));
    }

    if (status === 'ativo') {
      parametros.push('ativo=true');
    } else if (status === 'inativo') {
      parametros.push('ativo=false');
    }

    parametros.push('pagina=' + pagina);
    parametros.push('tamanhoPagina=' + tamanhoPagina);

    return this.GetValue('estadocidade/estadospaginado?' + parametros.join('&'));
  }

  public CriarEstado(value: any): Observable<any> {
    return this.SetValue('estadocidade/estado', value);
  }

  public EditarEstado(estadoId: string, value: any): Observable<any> {
    return this.UpdateValue('estadocidade/estado/' + estadoId, value);
  }

  public ExcluirEstado(estadoId: string): Observable<any> {
    return this.DeleteValue('estadocidade/estado/' + estadoId);
  }

  public ListarCidades(estadoId: string, filtro: string, status: string, pagina: number, tamanhoPagina: number): Observable<any> {
    const parametros: string[] = [];

    if ((filtro || '').trim()) {
      parametros.push('filtro=' + encodeURIComponent((filtro || '').trim()));
    }

    if (status === 'ativo') {
      parametros.push('ativo=true');
    } else if (status === 'inativo') {
      parametros.push('ativo=false');
    }

    parametros.push('pagina=' + pagina);
    parametros.push('tamanhoPagina=' + tamanhoPagina);

    return this.GetValue('estadocidade/cidadesporestado/' + estadoId + '?' + parametros.join('&'));
  }

  public CriarCidade(estadoId: string, value: any): Observable<any> {
    return this.SetValue('estadocidade/cidade/' + estadoId, value);
  }

  public EditarCidade(cidadeId: string, value: any): Observable<any> {
    return this.UpdateValue('estadocidade/cidade/' + cidadeId, value);
  }

  public ExcluirCidade(cidadeId: string): Observable<any> {
    return this.DeleteValue('estadocidade/cidade/' + cidadeId);
  }

  public ToggleEstado(estadoId: string): Observable<any> {
    return this.SetValue('estadocidade/toggleestado/' + estadoId, {});
  }

  public ToggleCidade(cidadeId: string): Observable<any> {
    return this.SetValue('estadocidade/togglecidade/' + cidadeId, {});
  }
}
